import * as React from "react";
import Svg, {
  G,
  Path,
  Defs,
  LinearGradient,
  Stop,
  ClipPath,
  Rect,
} from "react-native-svg";
const SVGComponent = (props: any) => (
  <Svg
    width={props.width || 360}
    height={props.height || 305}
    viewBox="0 0 360 305"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <G clipPath="url(#clip0_6888_6267)">
      <Path
        d="M228.61 0H289.533L217.533 110.769L200.918 105.231L228.61 0Z"
        fill="url(#paint0_linear_6888_6267)"
      />
      <Path
        d="M128.918 0H67.995L139.995 110.769L156.61 105.231L128.918 0Z"
        fill="url(#paint1_linear_6888_6267)"
      />
      <Path
        d="M-1.23901 129.854L-1.23987 47.077L121.706 129.858L112.302 146.777L-1.23901 129.854Z"
        fill="url(#paint2_linear_6888_6267)"
      />
      <Path
        d="M361.912 112.913L361.912 30.136L236.913 127.391L245.227 141.23L361.912 112.913Z"
        fill="url(#paint3_linear_6888_6267)"
      />
      <Path
        d="M-3.5852 192.321L-3.58606 275.098L119.36 192.317L109.956 175.398L-3.5852 192.321Z"
        fill="url(#paint4_linear_6888_6267)"
      />
      <Path
        d="M364.265 175.377L364.266 258.154L250.724 185.54L253.537 166.155L364.265 175.377Z"
        fill="url(#paint5_linear_6888_6267)"
      />
    </G>
    <Defs>
      <LinearGradient
        id="paint0_linear_6888_6267"
        x1={245.226}
        y1={0}
        x2={245.226}
        y2={110.769}
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="white" />
        <Stop offset={1} stopColor="white" stopOpacity={0} />
      </LinearGradient>
      <LinearGradient
        id="paint1_linear_6888_6267"
        x1={112.303}
        y1={0}
        x2={112.303}
        y2={110.769}
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="white" />
        <Stop offset={1} stopColor="white" stopOpacity={0} />
      </LinearGradient>
      <LinearGradient
        id="paint2_linear_6888_6267"
        x1={-12.582}
        y1={92.4995}
        x2={102.918}
        y2={139.5}
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="white" />
        <Stop offset={1} stopColor="white" stopOpacity={0} />
      </LinearGradient>
      <LinearGradient
        id="paint3_linear_6888_6267"
        x1={379.418}
        y1={68.0005}
        x2={245.418}
        y2={133}
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="white" />
        <Stop offset={1} stopColor="white" stopOpacity={0} />
      </LinearGradient>
      <LinearGradient
        id="paint4_linear_6888_6267"
        x1={-14.0815}
        y1={225.5}
        x2={104.418}
        y2={186.5}
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="white" />
        <Stop offset={1} stopColor="white" stopOpacity={0} />
      </LinearGradient>
      <LinearGradient
        id="paint5_linear_6888_6267"
        x1={393.419}
        y1={234.5}
        x2={259.419}
        y2={182.5}
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="white" />
        <Stop offset={1} stopColor="white" stopOpacity={0} />
      </LinearGradient>
      <ClipPath id="clip0_6888_6267">
        <Rect width={360} height={305} fill="white" />
      </ClipPath>
    </Defs>
  </Svg>
);
export default SVGComponent;
